module.exports = __webpack_public_path__ + "img/logo.01c722e3.svg";